var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"pageInfo\">\n    <div id=\"pgInfoWr\">\n        <h3 id=\"pgInfoModalHeader\">\n            <span class=\"icon-doc-text-1\"></span>\n            Page Information\n        </h3>\n        <ul class=\"pg-info-tbl-wr\"></ul>\n    </div>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/pageinfo/template.hbs
 ** module id = 260
 ** module chunks = 0
 **/